import Play from 'assets/icons/Play';
import PropTypes from 'prop-types';
import React from 'react';
import ThemeButton from 'components/buttons/ThemeButton';
import { above } from 'utils/mediaqueries';
import colors from 'config/theme/colors';
import styled from 'libs/styled';
import transitions from 'config/theme/transitions';
import useAboveBreakpoint from 'hooks/useAboveBreakpoint';

const StyledThemeButton = styled(ThemeButton)`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 1.6rem;

    ${above.md} {
        font-size: 1.8rem;
    }

    path {
        transition: all ${transitions.primary};
    }

    &:hover {
        path {
            stroke: ${colors.black};
        }
    }
`;

const VideoPlayButton = ({ children, ...rest }) => {
    const isAboveMd = useAboveBreakpoint('md');

    return (
        <StyledThemeButton size={isAboveMd ? 'lg' : 'md'} theme="outlinedWhite" {...rest}>
            {children}
            <Play ml="12px" color="currentColor" />
        </StyledThemeButton>
    );
};

VideoPlayButton.propTypes = {
    children: PropTypes.node.isRequired,
};

export default VideoPlayButton;
